import React from 'react';
import styles from '@app/product/index.module.less';
import ProductPage from '@app/product/ProductPage';
import { MODULES } from 'app/config/product/1000W-PRO-LED';

const Page: Globals.NextPage = () => {
    return <ProductPage modules={MODULES}/>
};

Page.pageConf = {
    bodyClassName: styles.body
};

export default Page;

